export const priceItems = [
    { title: "مهم نیست" },
    { title: "200 میلیون تومان", value: "2000000" },
    { title: "500 میلیون تومان", value: "500000" },
    { title: "1 میلیارد تومان", value: "1000000000" },
    { title: "3 میلیارد تومان", value: "3000000000" },
    { title: "5 ملیارد تومان", value: "5000000000" },
    { title: "7 میلیارد تومان", value: "7000000000" },
    { title: "10 میلیارد تومان", value: "10000000000" },
    { title: "15 میلیارد تومان", value: "15000000000" },
    { title: "20 میلیارد تومان", value: "20000000000" },
    { title: "30 میلیارد تومان", value: "30000000000" },
    { title: "50 میلیارد تومان", value: "50000000000" },
    { title: "90 میلیارد تومان", value: "90000000000" }

]

export const meterItems = [
    "75",
    "100",
    "125",
    "150",
    "175",
    "200",
    "250",
    "300",
    "400",
    "500"
]

export const dateTypes = [
    { title: "امروز", value: "امروز" },
    { title: "یک هفته اخیر", value: "یک هفته اخیر" },
    { title: "پانزده روز اخیر", value: "پانزده روز اخیر" },
    { title: "یک ماه اخیر", value: "یک ماه اخیر" },
    { title: "هفته جاری", value: "هفته جاری" },
    { title: "ماه جاری", value: "ماه جاری" },
    { title: "بازه دلخواه", value: "بازه دلخواه" },
]

export const labelColors = [
    "#EFB3AB",
    "#FAD29C",
    "#F5EA92",
    "#B7DDB0",
    "#CD8DE5",
    "#DFC0EB",
    "#EF7564",
    "#FFAF3F",
    "#F5DD29",
    "#7BC86C",
    "#A86CC1",
    "#CF513D",
    "#E79217",
    "#E6C60D",
    "#5AAC44",
    "#505F79",
    "#F9C2E4",
    "#B3F1D0",
    "#8FDFEB",
    "#8BBDD9",
    "#344563",
    "#FF8ED4",
    "#6DECA9",
    "#29CCE5",
    "#5BA4CF",
    "#091E42",
    "#E568AF",
    "#4ED583",
    "#00AECC",
    "#026AA7"]


export const messageTemplate = {
    Row: "کد ملک",
    CertificateType: "نوع ملک 🏠",
    Infrastructure: "زیر بنا 📐",
    RoomsCount: "تعداد اتاق 🔑",
    UsageType: "نوع کاربری",
    PropertyArea: "محدوده 📍",
    Facilities: "امکانات 💡",
    Aggregation: "تراکم",
    CertificateType: "نوع سند",
    Direction: "جهت ساختمان",
    PublicDescription: "توضیحات 📏",
    ChannelAddress: "آدرس کانال",
    StoreyCount: "تعداد طبقات",
    CommercialMeter: "متراژ تجاری",
    Adjective: "توصیف ملک",
    FullName: "کاربر ثبت کننده",
    AgencyMobile : "اطلاعات تماس کاربر ثبت شده",
    SalePrice: "قیمت فروش 💵",
    MortgagePrice1 : "قیمت رهن 💵",
    RentPrice1 : "قیمت اجاره 💵",
    PreSalePrice : "قیمت پیش فروش",
    Space : "مساحت",
    PropertyType : "نوع معامله"
    }


    export const satisfactionPercent = {
        "<50" : "کمتر از 50 درصد",
        "50-80" : "بین 50 تا 80 درصد",
        ">80" : "بیشتر از 80 درصد"
    }